import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchWorkoutsState } from "../../../interfaces/store/workouts-interface";
import { CARDS_PAGE_SIZE } from "../../../common/config";

const initialState: IFetchWorkoutsState = {
  workouts: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: CARDS_PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchWorkoutsStart = (
  state: IFetchWorkoutsState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchWorkoutsSuccess = (
  state: IFetchWorkoutsState,
  { payload }: PayloadAction<any>
) => {
  state.workouts = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchWorkoutsFailed = (
  state: IFetchWorkoutsState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetWorkouts = () => {
  return { ...initialState };
};

const WorkoutsSlice = createSlice({
  name: "workouts",
  initialState,
  reducers: {
    fetchWorkoutsStart: _fetchWorkoutsStart,
    fetchWorkoutsSuccess: _fetchWorkoutsSuccess,
    fetchWorkoutsFailed: _fetchWorkoutsFailed,
    resetWorkouts: _resetWorkouts,
  },
});

export const {
  fetchWorkoutsStart,
  fetchWorkoutsSuccess,
  fetchWorkoutsFailed,
  resetWorkouts,
} = WorkoutsSlice.actions;
export default WorkoutsSlice.reducer;
